"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const custom_grid_1 = __importDefault(require("./custom-grid"));
const store_1 = require("store");
const react_redux_1 = require("react-redux");
const pit_operation_style_1 = __importDefault(require("../pit-operation.style"));
const pit_operation_action_1 = __importDefault(require("../pit-operation.action"));
const react_router_dom_1 = require("react-router-dom");
const react_1 = require("react");
const authorization_1 = require("utils/authorization");
const header_menu_1 = __importDefault(require("components/molecules/header-menu"));
const svg_1 = require("components/atoms/svg");
const custom_cell_grid_1 = require("components/atoms/custom-cell-grid");
const pit_operation_mutation_component_1 = __importDefault(require("./pit-operation.mutation.component"));
const modal_1 = require("components/molecules/modal");
const pit_operation_column_1 = require("../pit-operation.column");
const pitOperation_1 = require("services/configuration/pitOperation");
const debounces_1 = require("utils/debounces");
const PitOperation = () => {
    const { isError, dataGrid, dataItem, isSuccess, isLoading, dataStates, filterChild, errorMessage, mutationMode, messageSuccess } = (0, store_1.useAppSelector)((state) => state.configuration.pitOperation);
    const { appTheme } = (0, store_1.useAppSelector)((state) => state.app);
    const { userData } = (0, store_1.useAppSelector)((state) => state.auth);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const [fullScreen, setFullScreen] = (0, react_1.useState)(true);
    const debounceCallback = (0, debounces_1.useDebouncedCallback)((newDataStates) => {
        dispatch(pit_operation_action_1.default.getDataGrid(newDataStates));
    }, 1000, [dispatch]);
    const isExternal = (0, authorization_1.isUserExternal)(userData.contractor_name);
    const isAuthorized = (0, authorization_1.userRoleAuth)(userData.authorization, 'Configuration', 'Pit Operation');
    const handleExternalInternalState = (isExternal) => {
        var _a;
        if (isExternal) {
            const newDataStates = Object.assign(Object.assign({}, dataStates), { filter: {
                    logic: 'and',
                    filters: [
                        ...((_a = dataStates.filter) === null || _a === void 0 ? void 0 : _a.filters) || [],
                        { field: 'contractor_name', operator: 'eq', value: userData.contractor_name }
                    ]
                } });
            return newDataStates;
        }
        else {
            return dataStates;
        }
    };
    (0, react_1.useEffect)(() => {
        if (isAuthorized.view) {
            if (isLoading) {
                debounceCallback({ dataStates: handleExternalInternalState(isExternal), filterChild });
            }
        }
        else {
            navigate('/dashboard', { replace: true });
        }
    }, [isLoading, isAuthorized, fullScreen, isExternal]);
    (0, react_1.useEffect)(() => {
        if (mutationMode === 'add' || mutationMode === 'edit') {
            dispatch(pit_operation_action_1.default.getDetail({ isExternal, contractor_name: userData.contractor_name }));
            dispatch(pit_operation_action_1.default.getDetailCheckpoint({ dataItem }));
            dispatch(pit_operation_action_1.default.getDetailDumpTruck({ dataItem }));
        }
        if (mutationMode === false) {
            const button = document.getElementById('button-add-new');
            button === null || button === void 0 ? void 0 : button.focus();
        }
    }, [mutationMode, isExternal]);
    const expandChange = (event) => {
        const data = dataGrid.map((item) => {
            return Object.assign(Object.assign({}, item), { expanded: event.id === item.id ? !item.expanded : false });
        });
        dispatch(pit_operation_action_1.default.onExpand({ dataGrid: data }));
    };
    const actionCellRender = (0, custom_cell_grid_1.actionCell)([
        {
            type: 'other',
            icon: (0, jsx_runtime_1.jsx)(svg_1.EditIcon, { color: appTheme === 'dark' ? '#fff' : '#424242' }),
            onClick: (d) => __awaiter(void 0, void 0, void 0, function* () {
                const response = yield (0, pitOperation_1._getPitOperationById)(d.id);
                dispatch(pit_operation_action_1.default.onClickMutation({
                    mutationMode: 'edit',
                    dataItem: Object.assign(Object.assign({}, d), { modified_by: userData.modified_by, is_active: {
                            value: Boolean(d.is_active),
                            status: d.is_active ? 'Active' : 'Inactive',
                        }, contractor: {
                            id: d.contractor_id,
                            contractor_name: d.contractor_name,
                        }, area: {
                            id: d.area_id,
                            area_name: d.area_name,
                        }, brand: {
                            id: d.brand_id,
                            name: d.brand_name,
                        }, excavator: {
                            id: d.excavator_id,
                            excavator_no: d.excavator_no,
                        }, pit: {
                            id: d.pit_id,
                            pit: d.pit_name,
                        }, checkpoint: {
                            checkpoint_name: d.checkpoint_name,
                            checkpoint_id: d.checkpoint_id
                        }, seam: {
                            id: d.seam_id,
                            seam: d.seam_name,
                            id_brand: d.brand_id,
                            brand_name: d.brand_name
                        }, dataChild: response.data.dataChild }),
                }));
            }),
            permission: isAuthorized.change,
        },
        {
            type: 'other',
            icon: (0, jsx_runtime_1.jsx)(svg_1.DeleteIcon, { color: appTheme === 'dark' ? '#fff' : '#424242' }),
            onClick: (d) => dispatch(pit_operation_action_1.default.onClickMutation({ mutationMode: 'delete', dataItem: d })),
            permission: isAuthorized.change,
        },
    ]);
    const expandCellRender = (0, custom_cell_grid_1.actionCell)([
        {
            type: 'expand',
            icon: '',
            onClick: (d) => expandChange(d),
            permission: true,
        },
    ]);
    const actionColumn = [
        {
            title: '',
            width: '40px',
            sortable: false,
            filterable: false,
            show: true,
            cell: expandCellRender,
            locked: true,
        },
        {
            title: '',
            width: '70px',
            sortable: false,
            filterable: false,
            show: isAuthorized.change,
            cell: actionCellRender,
            locked: true,
        },
    ];
    const onDataStateChange = (types, val) => {
        const newDataStates = Object.assign(Object.assign({}, dataStates), { skip: types === 'page' ? (val - 1) * dataStates.take : 0, take: types === 'take' ? val : dataStates.take });
        dispatch(pit_operation_action_1.default.onDataStateChange(newDataStates));
    };
    const onFilterChange = (e) => {
        dispatch(pit_operation_action_1.default.onFilterChange(e.filter));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { filter: e.filter });
        debounceCallback({ dataStates: newDataStates, filterChild: '' });
    };
    const onSortChange = (e) => {
        dispatch(pit_operation_action_1.default.onSortChange(e.sort));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { sort: e.sort });
        debounceCallback({ dataStates: newDataStates, filterChild });
    };
    const columnsRender = isExternal
        ? pit_operation_column_1.pitOperationColumnProps.map(item => {
            if (item.field === 'contractor_name') {
                return Object.assign(Object.assign({}, item), { filterable: false });
            }
            else {
                return item;
            }
        })
        : pit_operation_column_1.pitOperationColumnProps;
    const columnsRenderFullScreen = isExternal
        ? pit_operation_column_1.pitOperationColumnPropsFullScreen.map(item => {
            if (item.field === 'contractor_name') {
                return Object.assign(Object.assign({}, item), { filterable: false });
            }
            else {
                return item;
            }
        })
        : pit_operation_column_1.pitOperationColumnPropsFullScreen;
    //checkfullscreen
    const widthCheker = () => {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        setFullScreen(width >= window.screen.width);
    };
    (0, react_1.useEffect)(() => {
        widthCheker();
    }, []);
    window.onload = widthCheker;
    window.onresize = widthCheker;
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(header_menu_1.default, { theme: appTheme, isLoading: isLoading, title: 'Pit Operation', isAddNew: isAuthorized.change, onAddNew: () => dispatch(pit_operation_action_1.default.onClickMutation({ mutationMode: 'add' })) }), (0, jsx_runtime_1.jsx)(modal_1.ModalSuccess, { show: isSuccess, appTheme: appTheme, messageSuccess: messageSuccess, onClose: () => {
                    dispatch(pit_operation_action_1.default.onDataStateChange(dataStates));
                    dispatch(pit_operation_action_1.default.onClickMutation({ mutationMode: false, isSuccess: false }));
                } }), (0, jsx_runtime_1.jsx)(modal_1.ModalError, { appTheme: appTheme, show: isError, errorMessage: errorMessage, onClose: () => {
                    dispatch(pit_operation_action_1.default.closeError());
                    dispatch(pit_operation_action_1.default.onClickMutation({
                        mutationMode: mutationMode === 'delete' ? false : mutationMode,
                        isSuccess: false,
                        dataItem,
                    }));
                }, style: { zIndex: 10 } }), (0, jsx_runtime_1.jsx)(pit_operation_mutation_component_1.default, {}), (0, jsx_runtime_1.jsx)(custom_grid_1.default, { style: pit_operation_style_1.default.gridHeight, dataGrid: dataGrid, columns: actionColumn.concat(fullScreen ? columnsRenderFullScreen : columnsRender), dataStates: dataStates, fullScreen: fullScreen, pageable: true, sortable: true, sort: dataStates.sort, onPageChange: (v) => onDataStateChange('page', v), onTakeChange: (v) => onDataStateChange('take', v), onSortChange: onSortChange, onFilterChange: onFilterChange })] }));
};
exports.default = PitOperation;
